import { COLOR_PALETTE, mediaQuery, RESPONSIVE_PADDING } from 'constants/ui';

export const topSectionStyles = {
  display: 'flex',
  gap: '24px',
};

export const topSectionCustomStyles = {
  flex: '1',
  padding: '10px 0 24px !important',

  '.title': {
    paddingInline: '10px',
  },
};

export const loanDetailsStyles = {
  display: 'flex',
  padding: '0 12px',

  [mediaQuery.mobile]: {
    flexDirection: 'column',
    gap: RESPONSIVE_PADDING.MOBILE,
  },
};

export const gainLossStyles = {
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
  width: '50%',
  margin: '0 12px',

  [mediaQuery.mobile]: {
    width: '100%',
    margin: 0,
  },

  '& > div': {
    height: '70px',
    padding: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& > p': {
      fontSize: '14px',
      fontWeight: '500',
    },

    '& > div': {
      width: '240px',

      [mediaQuery.mobile]: {
        width: '100%',
      },
    },

    '&:last-child': {
      background: ({ palette }) => palette.background.secondary,
    },

    '&:not(:last-child)': {
      borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
    },
  },
};

export const profitLossStyles = {
  overflow: 'hidden',
  border: `1px solid ${COLOR_PALETTE.BRAND[6]}`,
  background: COLOR_PALETTE.BRAND[1],
  margin: '24px 12px 0 12px',
  borderRadius: '8px',
  width: 'calc(50% - 24px)',
  padding: '15px 15px 30px 15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',

  [mediaQuery.mobile]: {
    width: '100%',
    margin: `${RESPONSIVE_PADDING.MOBILE} 0 0 0`,
  },

  '& > div': {
    width: '240px',

    [mediaQuery.mobile]: {
      width: '100%',
    },
  },
};
